module.exports = __webpack_public_path__ + "img/cloud_op.0c76260e.png";